module.exports = __webpack_public_path__ + "img/256_s.30a273dd.svg";